import { useContext } from "react";
import Button from "../../../../components/Button/button";
import HouseModalContent from "../houseModalContent";
import AmenitiesDesktop from "./amenities-desktop";
import AmenitiesMobile from "./amenities-mobile";
import { HouseCompetitionData } from "../contextProvider";
import { useAppDispatch } from "../../../../redux/hooks";
import {
  publishModalClasses,
  publishModalData,
  publishModalVisibility,
} from "../../../../redux/features/modal/modalSlice";

const Amenities = ({ isDesktop }: { isDesktop: boolean }) => {
  const { amentiesImages } = useContext(HouseCompetitionData);
  const dispatch = useAppDispatch();

  const onShowAllAmeneties = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    dispatch(publishModalData({ modalData: <HouseModalContent activeTab={0} /> }));
    dispatch(
      publishModalClasses({
        classNames: "rounded-2xl lg:w-[450px] xs:w-[95%] top-[7rem] relative mb-[8rem]",
      })
    );
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  return (
    amentiesImages?.length > 0 && (
      <div className={`flex flex-col lg:pr-5 ${isDesktop ? "border-r-2 border-solid border-[#00000014]" : ""}`}>
        <h5 className="font-jost text-[20px] font-medium text-[#28282B] normal-case">What this place offers</h5>
        <div className={`mt-4`}>
          {isDesktop ? <AmenitiesDesktop amenities={amentiesImages} /> : <AmenitiesMobile amenities={amentiesImages} />}
        </div>
        <Button
          className="lg:text-[16px] xs:text-[14px] uppercase flex items-center text-[#6679B3] bg-white rounded mt-4 relative font-jost w-fit font-medium"
          onClick={onShowAllAmeneties}
          text="Show all amenities">
          <img
            className="absolute right-[-15px] invert"
            src="/assets/images/chevron.png"
            alt="view full results"
            width={10}
            height={10}
          />
        </Button>
      </div>
    )
  );
};

export default Amenities;
